import { FC } from 'react';
import { CatNumericInput } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { DEBOUNCE_TIME_MILLISECONDS } from 'constants/common';
import { debounce } from '@cat-ecom/common/utils/commonUtils';
import {
  PARTS_MAX_QUANTITY,
  PARTS_MIN_QUANTITY
} from 'constants/parts-diagram';
import styles from './quantity-input.module.scss';

export interface QuantityInputProps {
  inputValue: string;
  disabled?: boolean;
  handleQuantityChange: (value: string) => void;
}
const QuantityInput: FC<QuantityInputProps> = ({
  inputValue,
  disabled,
  handleQuantityChange
}) => {
  const t = useTranslations();

  const valHandle = debounce((e) => {
    const validateValue = (
      e.detail.value >= PARTS_MAX_QUANTITY ? PARTS_MAX_QUANTITY : e.detail.value
    )?.toString();

    handleQuantityChange(validateValue);
  }, DEBOUNCE_TIME_MILLISECONDS);
  return (
    <CatNumericInput
      data-testId="quantity_field"
      hideLabel
      size="sm"
      max={PARTS_MAX_QUANTITY}
      min={PARTS_MIN_QUANTITY}
      value={Number(inputValue)}
      onBlNumericInputChange={valHandle}
      disabled={disabled}
      className={styles['quantity_input']}
      status={Number(inputValue) >= PARTS_MIN_QUANTITY ? null : 'error'}
    >
      {Number(inputValue) < PARTS_MIN_QUANTITY && (
        <span slot="error">{t('SKULIST_INVALID_QUANTITY')}</span>
      )}
    </CatNumericInput>
  );
};

export default QuantityInput;
